import React from 'react';
import { styled } from '@mui/material/styles';
import { PeekDivider } from './PeekDivider.js';
import { PeekSkeleton } from './PeekSkeleton.js';
import { PeekStack } from './PeekStack.js';

const CustomDivider = styled(PeekDivider)(({ theme }) => ({
    borderColor: theme.palette.grey[200],
}));
const PeekTableSkeletonLoader = ({ numberOfLines }) => {
    return (React.createElement(PeekStack, { "data-testid": "skeleton-loader", direction: "column", pt: 2, spacing: 2 }, [...Array(numberOfLines)].map((_value, i) => (React.createElement(PeekStack, { direction: "column", spacing: 2, key: i },
        React.createElement(PeekSkeleton, { variant: "text", width: "100%", height: 12 }),
        React.createElement(CustomDivider, null))))));
};

export { CustomDivider, PeekTableSkeletonLoader, PeekTableSkeletonLoader as default };
